import React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { Colors } from "../Styles/Colors";

function Loader({ loaderOpen }) {
  return (
    <Backdrop
      sx={{ color: Colors.ThemeColor, zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={loaderOpen || false}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}

export default Loader;
